import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './cookieconsent-overrides.css';
import buildCookieConsentConfig from './config';

const CookieConsentBanner = ({ data }) => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.CookieConsent = CookieConsent;
            CookieConsent.run(buildCookieConsentConfig(data));
        }
    }, [data]);

    return null;
};

export default CookieConsentBanner;
